/**
 * Marketing Studio availability — disabled unless REACT_APP_MARKETING_STUDIO_ENABLED=true
 * at build time. Mirrors paymentsAvailability so the studio ships dormant.
 */

export const MARKETING_STUDIO_ENABLED = process.env.REACT_APP_MARKETING_STUDIO_ENABLED === 'true';

export const MARKETING_STUDIO_DISABLED_TEST_ID = 'marketing-studio-disabled-notice';

export function isMarketingStudioEnabled() {
  return MARKETING_STUDIO_ENABLED;
}
